import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Field, Formik } from 'formik';

import { ComboBox, Button, Toggler, TextInput, Icons } from '@components';
import { cpaSchema, CpaInitialValues, CPADocs } from '@schemas';
import { mdiFileDownloadOutline } from '@mdi/js';
import { enviarRequerimentoFormulario } from '../../../../store/requerimentos/thunks';
import { ModalUpload } from './components/ModalUpload';
import { validaUpload } from './utils/validaUpload';
import { RequerimentoService } from '../../../../common/services/requerimento';
import { DadosUsuario } from './components/DadosUsuario';

const Anexos = ({ estaAposentado, foiJulgado, houveProcessoJudicial }) => {
  const [doc, setDoc] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const docs = CPADocs;

  useEffect(() => {
    if (estaAposentado === 'Não') {
      setDoc(CPADocs.naoAposentado);
    }

    if (estaAposentado === 'Sim' && houveProcessoJudicial === 'Não') {
      setDoc(CPADocs.admin);
    }

    if (
      estaAposentado === 'Sim' &&
      houveProcessoJudicial === 'Sim' &&
      foiJulgado === 'Sim'
    ) {
      setDoc(CPADocs.julgado);
    }

    if (
      estaAposentado === 'Sim' &&
      houveProcessoJudicial === 'Sim' &&
      foiJulgado === 'Não'
    ) {
      setDoc(CPADocs.tutela);
    }
  }, [estaAposentado, foiJulgado, houveProcessoJudicial]);

  return (
    <>
      <ModalUpload modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      {docs.commons.map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
      {/* {showMolestiaDocs &&
        docs.molestiaGrave.map((anexo) => (
          <div className="row" key={anexo.name}>
            <div className="col-md-12 col-lg-6">
              <Field
                className="mb-3"
                name={anexo.name}
                type="file"
                label={anexo.label}
                accept="image/*,.pdf"
              >
                {({ form }) => {
                  return (
                    <TextInput
                      className="mb-3"
                      name={anexo.name}
                      type="file"
                      label={anexo.label}
                      accept="image/*,.pdf"
                      multiple
                      onChange={(e) => {
                        return validaUpload({
                          anexo,
                          e,
                          form,
                          setModalIsOpen,
                        });
                      }}
                    />
                  );
                }}
              </Field>
            </div>
          </div>
        ))} */}
      {doc.map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
    </>
  );
};

const service = new RequerimentoService();

export const Cpa = ({ title, reference }) => {
  const [fileURL, setFileURL] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    service
      .obterTermoJudicial()
      .then((URL) => setFileURL(URL))
      .finally(() => setLoading(false));
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const envioLoading = useSelector(
    (state) => state.requerimentos.envio.loading
  );

  const [showForm, setShowForm] = useState(false);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        {showForm ? (
          <>
            {loading ? (
              <p className="mb-4">Carregando termo de compromisso...</p>
            ) : (
              <a
                href={fileURL}
                rel="noreferrer"
                target="_blank"
                download
                title="Clique para termo de compromisso"
                className="w-250 mb-4 d-md-flex ts-14 mb-2 mt-4 align-items-center justify-content-between text-decoration-none fw-bold primary-color"
              >
                Baixar termo de compromisso
                <Icons
                  path={mdiFileDownloadOutline}
                  color="var(--primary-color)"
                />
              </a>
            )}
            <p className="mb-4">
              Venho requerer a Fundação Forluminas de Seguridade Social -
              FORLUZ, que me seja paga a Complementação Proporcional de
              Aposentadoria, em acordo ao regulamento e normas em vigor ao Plano
              Saldado (Plano A), conforme minha opção. Para tanto, anexo a
              documentação necessária para tal fim.
            </p>
            <Formik
              validateOnMount
              initialValues={CpaInitialValues}
              validationSchema={cpaSchema}
              onSubmit={(values) => {
                dispatch(
                  enviarRequerimentoFormulario({
                    campos: values,
                    formulario: reference,
                  })
                )
                  .unwrap()
                  .then(() => {
                    navigate('/requerimentos/andamento');
                  });
              }}
            >
              {({ handleSubmit, isValid, values, setFieldValue }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="estaAposentadoINSS"
                          component={ComboBox}
                          options={['Sim', 'Não'].map((x) => {
                            return { value: x, label: x };
                          })}
                          label="Está aposentado pelo INSS?"
                          onChange={(op) => {
                            if (op.value === 'Não') {
                              setFieldValue('houveProcessoJudicial', '', false);
                              setFieldValue('foiJulgado', '', false);
                              setFieldValue('atividadeRural', '', false);
                              setFieldValue('processoJudicial', '', false);
                            }
                          }}
                        />
                      </div>

                      <div className="col-md-12 col-lg-6">
                        <Field
                          disabled={!(values.estaAposentadoINSS === 'Sim')}
                          className="mb-3"
                          name="houveProcessoJudicial"
                          component={ComboBox}
                          options={['Sim', 'Não'].map((x) => {
                            return { value: x, label: x };
                          })}
                          label="Houve processo judicial?"
                          onChange={(op) => {
                            if (op.value === 'Não') {
                              setFieldValue('foiJulgado', '', false);
                              setFieldValue('processoJudicial', '', false);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      {values.houveProcessoJudicial === 'Sim' && (
                        <div className="col-md-12 col-lg-6">
                          <Field
                            disabled={!(values.houveProcessoJudicial === 'Sim')}
                            className="mb-3"
                            name="processoJudicial"
                            component={TextInput}
                            type="number"
                            label="Número do processo judicial"
                          />
                        </div>
                      )}

                      <div className="col-md-12 col-lg-6">
                        <Field
                          disabled={!(values.houveProcessoJudicial === 'Sim')}
                          className="mb-3"
                          name="foiJulgado"
                          component={ComboBox}
                          options={['Sim', 'Não'].map((x) => {
                            return { value: x, label: x };
                          })}
                          label="Transitou em julgado?"
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          disabled={!(values.estaAposentadoINSS === 'Sim')}
                          className="mb-3"
                          name="atividadeRural"
                          label="Atividade rural?"
                          component={ComboBox}
                          options={['Há incidência', 'Não há incidência'].map(
                            (x) => {
                              return { value: x, label: x };
                            }
                          )}
                          onChange={(op) => {
                            if (op.value === 'Não há incidência') {
                              setFieldValue('tempoRuralAnos', '', false);
                              setFieldValue('tempoRuralMeses', '', false);
                              setFieldValue('tempoRuralDias', '', false);
                            }
                          }}
                        />
                      </div>

                      <div className="col-md-12 col-lg-6">
                        <div className="label">Tempo de atividade rural?</div>
                        <div className="tempoRural__Container">
                          <Field
                            disabled={
                              !(values.atividadeRural === 'Há incidência')
                            }
                            name="tempoRuralAnos"
                            label="Anos"
                            component={TextInput}
                            type="number"
                            className="numberInput__Container"
                          />

                          <Field
                            disabled={
                              !(values.atividadeRural === 'Há incidência')
                            }
                            name="tempoRuralMeses"
                            label="Meses"
                            component={TextInput}
                            type="number"
                            className="numberInput__Container"
                            min={0}
                            max={11}
                          />

                          <Field
                            disabled={
                              !(values.atividadeRural === 'Há incidência')
                            }
                            name="tempoRuralDias"
                            label="Dias"
                            component={TextInput}
                            type="number"
                            className="numberInput__Container"
                            min={0}
                            max={29}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="adiantamentoQuinzenal"
                          component={ComboBox}
                          tooltip="Antecipação de 35% do valor bruto, pago no dia 15 de cada mês."
                          label="Adiantamento quinzenal?"
                          options={['Sim', 'Não'].map((x) => {
                            return { value: x, label: x };
                          })}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="acessoContraCheque"
                          label="Acesso ao contracheque via"
                          component={ComboBox}
                          options={['Portal', 'E-mail e portal'].map((x) => {
                            return { value: x, label: x };
                          })}
                        />
                      </div>

                      {/* <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="acessoJornalForluz"
                          component={ComboBox}
                          label="Acesso Jornal Forluz"
                          options={['Digital', 'Impresso'].map((x) => {
                            return { value: x, label: x };
                          })}
                        />
                      </div> */}
                    </div>

                    <div className="row">
                      <div className="col-md-12 ">
                        <Field
                          className="mb-3"
                          name="consentimentoDescontoFolha"
                          component={Toggler}
                          label="Declaro estar ciente de que a Forluz operacionalizará
                          os descontos decorrentes de eventual relacionamento
                          com as Entidades Externas (ABCF; AEA; AIC; ANAPAR;
                          CECREMEC; CEMIG SAÚDE; CLIC; GREMIG; SEGURO DE VIDA;
                          SINDICATO JUIZ DE FORA; SINDIELETRO; SINDSUL), por
                          meio de descontos no meu benefício para repasse à(s)
                          Entidade(s), os quais poderão ser visualizados
                          mensalmente no contracheque. Declaro estar ciente,
                          ainda, de que devo contatar diretamente a Entidade à
                          qual sou filiado para o cancelamento das cobranças
                          e/ou ressarcimento de qualquer valor."
                        />

                        <Field
                          className="mb-3"
                          name="consentimentoAjustePagamento"
                          component={Toggler}
                          createTermsField
                          label="Autorizo que, em caso de falecimento, créditos e débitos oriundos de resíduos e adiantamentos anteriores ao óbito, ou valores processados indevidamente após essa data, sejam descontados ou creditados em favor dos meus beneficiários de renda continuada por morte do plano de benefícios."
                        />

                        <Field
                          className="mb-3"
                          name="consentimentoDadosSensiveis"
                          component={Toggler}
                          label="Com base na Lei nº 13.709/2018 (Lei Geral de Proteção
                          de Dados Pessoais), autorizo o tratamento dos meus
                          dados pessoais e dados pessoais sensíveis para fins
                          relacionados ao meu vínculo com a FORLUZ."
                        />
                      </div>
                      <Field
                        className="mb-3"
                        name="aceiteInss"
                        component={Toggler}
                        createTermsField
                        label="Estou ciente que pessoa aposentada pela Previdência Oficial (INSS) e acometida por moléstia grave faz jus à isenção de Imposto de Renda. Este pedido poderá ser solicitado à Forluz a qualquer tempo através do formulário Isenção de Imposto de Renda disponível no menu Requerimentos. Se deferida, a isenção será processada no mês seguinte ao requerimento. "
                      />
                    </div>

                    <Anexos
                      estaAposentado={values.estaAposentadoINSS}
                      foiJulgado={values.foiJulgado}
                      houveProcessoJudicial={values.houveProcessoJudicial}
                    />

                    <Field
                      className="mb-3"
                      name="declaracaoVeracidade"
                      component={Toggler}
                      label="Declaro que as informações e os documentos por mim apresentados à Forluz são verdadeiros, estando ciente de que, caso não sejam autênticos, estarei sujeito às consequências civis e criminais cabíveis, além de autorizar a Forluz a anular o ato praticado ou o benefício concedido."
                    />

                    <hr className="mt-32 mt-xs-0 mb-32" />
                    <div className="row">
                      <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                        <div className="d-block d-md-flex align-items-center">
                          <Button
                            disabled={!isValid || envioLoading}
                            className="ms-0 ms-md-3"
                            onClick={handleSubmit}
                          >
                            Continuar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </>
        ) : (
          <DadosUsuario
            onClick={() => {
              window.scroll(0, 0);
              setShowForm(true);
            }}
            dadosBancarios
          />
        )}
      </div>
    </div>
  );
};
